import { useState } from "react";

import { Helmet } from "react-helmet";
import { NotificationManager } from "react-notifications";
import * as Yup from "yup";
import { Formik, Field, ErrorMessage } from "formik";
import MemberAutocomplete from "./MemberAutocomplete";
import CreditTransactionHistory from "./CreditTransactionHistory";
// import { setUserData } from "app/store/actions/UserActions";
// import jwtAuthService from "app/services/jwtAuthService";

import { depositAmountByDistributor } from "app/services/memberService";

const validationSchema = Yup.object().shape({
  memberId: Yup.number().required("Please select member"),
  amount: Yup.number().required("Please enter amount"),
  manualProcessType: Yup.string().required("Please select credit type"),
  remarks: Yup.string().nullable(),
});

const ManualCRDR = () => {
  const [memberId, setMemberId] = useState("");
  const [manualProcessType, setManualProcessType] = useState("Credit");
  const [amount, setAmount] = useState(0);
  const [remarks, setRemarks] = useState("");
  const [optionResponse, setOptionResponse] = useState([
    { value: 0, label: "" },
  ]);

  const submitForm = async (values, { resetForm }) => {
    try {
      const res = await depositAmountByDistributor({
        memberId: values.memberId,
        amount: values.amount,
        remarks: values.remarks,
        manualProcessType: values.manualProcessType,
      });
      if (res.status == "Success") {
        NotificationManager.success(res.message);
      } else {
        NotificationManager.error(res.message);
      }
      resetForm({ values: "" });
      // await jwtAuthService.loginWithToken().then((user) => {
      //   dispatch(setUserData(user));
      // });
    } catch (error) {
      NotificationManager.error("Something went wrong");
      throw error;
    }
  };

  return (
    <div>
      <Helmet>
        <title>Manual Credit / Debit</title>
      </Helmet>
      <div className="mb-4">
        <h5 className="font-weight-bold">Manual Credit</h5>
        <Formik
          onSubmit={submitForm}
          initialValues={{ memberId, amount, manualProcessType, remarks }}
          validationSchema={validationSchema}
        >
          {({
            setFieldValue,
            handleSubmit,
            touched,
            values,
            errors,
            handleChange,
            handleBlur,
          }) => (
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label className="font-weight-bold">Username</label>
                <span className="text-danger"> *</span>
                <MemberAutocomplete
                  setFieldValue={setFieldValue}
                  memberId={memberId}
                  handleChangeOptions={(memberId) => {
                    setFieldValue("memberId", memberId);
                    // this.setState({ memberId });
                  }}
                  name="memberId"
                  value={values.memberId}
                />
                {!values.memberId ? (
                  <p className="text-danger">{errors.memberId}</p>
                ) : (
                  ""
                )}
              </div>
              <div className="form-group">
                <label className="font-weight-bold">Credit Amount</label>
                <span className="text-danger"> *</span>

                <input
                  type="number"
                  className="form-control w-100"
                  name="amount"
                  display=" Amount"
                  value={values.amount}
                  error={errors.amount}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  touched={touched.amount}
                />
                <div>
                  {errors.amount && touched.amount ? (
                    <p className="text-danger"> {errors.amount} </p>
                  ) : (
                    ""
                  )}
                </div>
              </div>

              <div className="form-group">
                <label className="font-weight-bold">Transaction Type</label>
                <input
                  type="text"
                  className="form-control w-100"
                  name="manualProcessType"
                  display="creditType"
                  value={values.manualProcessType}
                  error={errors.manualProcessType}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  touched={touched.manualProcessType}
                  disabled
                />
                <div>
                  {errors.manualProcessType && touched.manualProcessType ? (
                    <p className="text-danger"> {errors.manualProcessType} </p>
                  ) : (
                    ""
                  )}
                </div>
              </div>

              {/* <div className="form-group">
                      <label className="font-weight-bold">
                        Transaction Type
                      </label>
                      <span className="text-danger"> *</span>

                      <input
                        type="text"
                        className="form-control w-100"
                        name="creditType"
                        display="DR/ CR"
                        value={values.creditType}
                        error={errors.creditType}
                        onBlur={handleBlur}
                      />
                      <div>
                        {errors.creditType && touched.creditType ? (
                          <p className="text-danger"> {errors.creditType} </p>
                        ) : (
                          ""
                        )}
                      </div>
                    </div> */}
              <div className="form-group">
                <label className="font-weight-bold">Remarks</label>
                <textarea
                  className="form-control w-100"
                  name="remarks"
                  display=" Remarks"
                  value={values.remarks}
                  error={errors.remarks}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  touched={touched.remarks}
                />
                <div>
                  {errors.remarks && touched.remarks ? (
                    <p className="text-danger"> {errors.remarks} </p>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <div className="form-group">
                <button className="btn btn-sm btn-primary" type="submit">
                  {" "}
                  Submit
                </button>
              </div>
            </form>
          )}
        </Formik>
      </div>
      <CreditTransactionHistory
        creditType={manualProcessType}
        memberId={memberId}
      />
    </div>
  );
};

export default ManualCRDR;
